import { types, type Instance, getRoot } from 'mobx-state-tree';

import type { IStore } from './../Store/index';

const Note = types
  .model('Note', {
    id: types.identifier,
    content: types.optional(types.string, ''),
    createdUser: types.optional(types.string, ''),
    createdDate: types.optional(types.string, ''),
    createdUserId: types.optional(types.number, -1),
  })
  .views((self) => ({
    get rootStore(): IStore {
      return getRoot(self);
    },
  }))
  .views((self) => ({
    get canDelete() {
      const userId = self.rootStore.userStore.user.userId;

      return self.createdUserId === userId;
    },
  }));

export type INote = Instance<typeof Note>;

export default Note;
